{
  "fr": {
    "ticket_category": {
      "Decisions": "Décision",
      "Issue": "Après-vente",
      "Other": "Réguliers",
      "labels": {
        "ticket_category": "Type"
      }
    }
  }
}
